var FieldRaceMessageRMQ = [
  { name: "Class", type: "str" },
  { name: "Purse", type: "str" },
  { name: "Surface", type: "str" },
  { name: "Distance", type: "str" },
  { name: "RaceDesc", type: "str" },
  { name: "ActualCloseMethod", type: "int" },
  { name: "CloseMethod", type: "int" },
  { name: "Win", type: "bool" },
  { name: "Place", type: "bool" },
  { name: "Show", type: "bool" },
  { name: "Pick3", type: "bool" },
  { name: "Pick4", type: "bool" },
  { name: "Pick5", type: "bool" },
  { name: "Pick6", type: "bool" },
  { name: "Pick7", type: "bool" },
  { name: "Pick8", type: "bool" },
  { name: "Pick9", type: "bool" },
  { name: "Pick10", type: "bool" },
  { name: "Pick11", type: "bool" },
  { name: "Pick12", type: "bool" },
  { name: "DailyDouble", type: "bool" },
  { name: "Exacta", type: "bool" },
  { name: "Trifecta", type: "bool" },
  { name: "Superfecta", type: "bool" },
  { name: "Quinella", type: "bool" },
  { name: "HouseQ", type: "bool" },
  { name: "High5", type: "bool" },
  { name: "Omni", type: "bool" },
];

export default FieldRaceMessageRMQ;
